import * as React from "react"
import Layout from "../components/Layout"
import { Helmet } from "react-helmet-async"
import './styles/home-parceiros.scss'
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"

const HomeParceirosPage = ({ data }) => {
  const breadC = {
    visible: true,
    color: "white",
    items: [
      { path: "/", name: "Home" },
      { path: "/home-parceiros/", name: "Parceiros DIA +" },
    ],
  }

  return (
    <Layout breadCrumb={breadC}>
      <Helmet>
        <html lang="pt-BR" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Parceiros - Dia Supermercados</title>
        <meta
          name="description"
          content="Somos a marca própria mais vendida no Brasil. Conheça os pilares da marca. Melhor a Cada DIA."
        />
        <meta name="keywords" content="produtos dia, marca propria" />
        <meta name="author" content="DIA Supermercados" />
      </Helmet>
      <div className="home-parceiros-page">
        <main>
          <section>
              <div className="banner-container" id="TopPage">
                <GatsbyImage
                  image={data.imgDesktop.childImageSharp.gatsbyImageData}
                  className="position-relative d-lg-block d-none"
                  alt="Carrinhos de Supermercado"
                />
              </div>
            </section>
          <section className="container py-7 text-center">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8">
                <p className="lead font-weight-bold">
                  Quer ajudar quem está com você a economizar no supermercado? <br />
                  Temos um benefício ideal e exclusivo para oferecer ainda mais vantagens a quem faz parte do seu dia a dia — seja em uma empresa, condomínio, academia... <br />
                  Como nosso parceiro, você garante 5% de desconto direto no app ClubDia, além de outras vantagens exclusivas. <br />
                  Venha ser ClubDIA+!
                </p>
                <div className="button-group mt-4">
                  <a href="/cadastro-empresa" className="btn btn-danger rounded-pill px-5 py-4 mx-2">
                    Sou CNPJ
                  </a>
                  <a href="/cadastro-colaborador/" className="btn btn-danger rounded-pill px-5 py-4 mx-2">
                    Sou CPF
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </Layout>
  )
}

export default HomeParceirosPage

export const query = graphql`
  {
    imgDesktop: file(relativePath: { eq: "parceiros/banner.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH)
      }
    }
    imgMobile: file(relativePath: { eq: "parceiros/banner.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, width: 360, height: 240, layout: CONSTRAINED)
      }
    }
  }
`
